import Model, { attr, type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { TotalRevenueHotel } from 'lumen/models';

export default class TotalRevenuePortfolio extends Model {
  [Type] = 'total-revenue/portfolio' as const;

  @hasMany('total-revenue/hotel', { async: false, inverse: null })
  declare hotels: HasMany<TotalRevenueHotel>;

  @attr declare name: string;
}
